import { AccountingTarget, AccountingTargetListItem } from "../../model";
import { Ajax, CrudApiBase } from "../infra";

/**
 * Provides CRUD access for Accounting Targets
 */
export class AccountingTargets extends CrudApiBase<AccountingTarget, AccountingTargetListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/accounting-target";

  constructor(ajax: Ajax) {
    super(ajax);
  }

  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(): AccountingTarget {
    return {
      info: {
        availableMethods: [],
        target: {
          avatar: {},
        },
        data: {},
      },
      ruleSet: {
        accounts: [],
        rows: [],
        targetCoA: [],
      },
      workflowData: {
        events: [],
      },
    };
  }
}
